import React from "react";
import ReactSelect, { components } from "react-select";

const Option = ({ innerProps, ...props }) => {
  const { label, value, tooltipContent } = props.data;
  const newInnerProps = {
    ...innerProps,
    "data-for": value,
    "data-tip": tooltipContent,
    // data-event likely isn't needed as we are coercing the className of the tooltip class to show when react-select indicates that the option is focused.
    "aria-label": "option",
  };

  const classNames = `cb-select-tooltip ${props.isFocused ? "show" : ""}`;

  return (
    <abbr title={tooltipContent}>
      <components.Option
        {...props}
        innerProps={newInnerProps}
        className="select-option"
      />
    </abbr>
  );
};

const TeamStatusSelector = (props) => {
  const styles = {
    dropdownIndicator: (provided) => ({
      ...provided,
      svg: {
        fill: "#2eb790",
      },
    }),
    menu: (provided) => ({
      ...provided,
      width: "90%",
      margin: "5px 5%",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    option: (provided, state) => {
      const defaultValues = {
        ...provided,
        color: state.data.color,
        border: "none",
        borderTop: state.data.borderTop && state.data.borderTop,
        paddingLeft: "5px",
        fontSize: "16px",
      };
      if (state.data.bgColor && state.isSelected) {
        defaultValues.backgroundColor = state.data.bgColor;
        defaultValues.color = "white";
      }
      return defaultValues;
    },
    input: (provided) => ({
      ...provided,
      minWidth: '100px',
    })
  };

  const theme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "rgba(39, 170, 131, 0.2)",
      primary: "rgba(39, 170, 131, 1)",
      primary50: "rgba(39, 170, 131, 0.6)",
    },
  });

  return (
    <ReactSelect
      {...props}
      styles={styles}
      theme={theme}
      components={{ Option }}
    />
  );
};

export default TeamStatusSelector;
